import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const CountriesModelSchema = z
  .object({
    code: z.string(),
    name: z.string()
  })
  .strict()

const CountriesModelFields = makeFieldKeys(CountriesModelSchema)

export type CountriesModel = z.infer<typeof CountriesModelSchema>

function validateCountriesModel(data: unknown): CountriesModel {
  try {
    return validateWithZodSchema(CountriesModelSchema, data, 'countries model')
  } catch (error) {
    throw new Error(`Countries model validation failed: ${error}`)
  }
}
